import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {defaultTags, ModelTag} from '../../../../models/CreatorModels';

@Component({
    selector: 'app-add-options-dialog',
    templateUrl: './add-options-dialog.component.html',
    styleUrls: ['./add-options-dialog.component.scss']
})
export class AddOptionsDialogComponent implements OnInit {
    editorInstance: any;
    options: any[] = [];
    value: string;
    type: string;
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
    count: number = this.options.length;
    displayColumns: ['id', 'label', 'actions'];
    newRecordLabel: string;
    editorStyle: any;
    showInfo: boolean;
    defaultMemberTags: ModelTag[] = defaultTags;
    valueToText: string;
    public editorOptions = {
        theme: 'snow',
        modules: {
            toolbar: {
                container:
                    [
                        [{ placeholder: ['[GuestName]', '[HotelName]'] }], // my custom dropdown
                        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                        ['blockquote', 'code-block'],
                        ['clean']                                    // remove formatting button

                    ],
                handlers: {
                    placeholder: (value) => {
                        if (value) {
                            // const cursorPosition = this.quill.getSelection().index;
                            // this.quill.insertText(cursorPosition, value);
                            // this.quill.setSelection(cursorPosition + value.length);
                        }
                    }
                }
            }
        }
    };

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AddOptionsDialogComponent>) {
        this.showInfo = false;
        if (data.type === 'label') {
            this.type = 'label';
            this.value = data.value;
            this.valueToText = '';
            this.editorStyle = {height: '500px'};
        } else {
            this.type = 'options';
            this.options = data.options;
            this.newRecordLabel = '';
        }
    }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource<any>(this.options);
    }

    close(data?: any) {
        if (this.data.type === 'label') {
            this.dialogRef.close(this.value);
        } else {
            this.dialogRef.close(data);
        }
    }

    deleteOption(option) {
        const index = this.options.findIndex(o => o.id === option.id);
        if (index !== -1) {
            this.options.splice(index, 1);
        }

        for (const opt of this.options) {
            if (opt.id !== 1 && opt.id > option.id) {
                opt.id--;
            }
        }

        this.dataSource = new MatTableDataSource<any>(this.options);
    }

    addOption() {
        const model = {
            id: this.options.length + 1,
            value: '',
            label: this.newRecordLabel
        };
        this.options.push(model);
        this.dataSource = new MatTableDataSource<any>(this.options);

        this.newRecordLabel = '';
    }

    showHideInfo() {
        this.showInfo = !this.showInfo;
    }

    appendToEditor(preDefinedValue: string) {
        // this.value += preDefinedValue;
        // this.editor.content.insertText(3, preDefinedValue, true);
        const currentText = this.editorInstance.getText();
        this.editorInstance.insertText(currentText.length, preDefinedValue);
    }

    created($event: any) {
        this.editorInstance = $event;
        this.editorInstance.root.innerHTML = this.value;
    }

    dropped($event: DragEvent) {
        console.log($event);
    }
}
